"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/serviceSlider.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FC, ComponentProps } from "react";

type HomeNineServiceSliderServicesOneItem = {
    /** Detected variants: "ECG & diagnostic coordination" | "Antibiotic therapy support" | "Medication administration" | "IV fluids & injections" | "Oxygen therapy" */
    text: string;
};

type HomeNineServiceSliderServicesTwoItem = {
    /** Detected variants: "Recovery after surgery" | "Physiotherapy coordination" | "Stroke rehabilitation support" | "Palliative & End-of-life care" */
    text: string;
};
export type HomeNineServiceSliderGeneratedProps = {
    servicesOne?: HomeNineServiceSliderServicesOneItem[];
    servicesTwo?: HomeNineServiceSliderServicesTwoItem[];
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionSwiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    sectionSwiper1SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeNineServiceSliderGenerated: FC<HomeNineServiceSliderGeneratedProps> = ({
    servicesOne = [],
    servicesTwo = [],
    sectionDataWowDuration = "1s",
    sectionSwiper0SwiperProps,
    sectionSwiper1SwiperProps,
}) => {
    return (
        <section className="slider-section-nine wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <Swiper modules={[Autoplay]} spaceBetween={16} slidesPerView="auto" loop={true} speed={15000} autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: false
            }} className="horizontal-slide slide-one slide-nine bg-primary d-flex" {...(sectionSwiper0SwiperProps ?? {})}>
                {servicesOne.map((service, index) => (
                    <SwiperSlide key={index} className="services-slide" style={{ width: "auto" }}>
                        <h3>{service.text}</h3>
                    </SwiperSlide>
                ))}
            </Swiper>
            <Swiper modules={[Autoplay]} spaceBetween={16} slidesPerView="auto" loop={true} speed={15000} autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true
            }} className="horizontal-slide slide-two slide-nine-two bg-dark d-flex" {...(sectionSwiper1SwiperProps ?? {})}>
                {servicesTwo.map((service, index) => (
                    <SwiperSlide key={index} className="services-slide" style={{ width: "auto" }}>
                        <h3>{service.text}</h3>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default HomeNineServiceSliderGenerated;
